import React from "react";
import { MARKET_PLACE } from "src/constants/routes";
import { useNavigate } from "react-router-dom";

function GangstaProperties({ propertiesList, isGangster, className }) {
  console.log(propertiesList);
  console.log(isGangster);
  const navigate = useNavigate();

  const handleRedirection = (type, name) => {
    navigate(`${MARKET_PLACE.INDEX}?attribute=${type}-${name}`);
  };
  const checkMod2 = (index, propertiesList, data) => {
    let i = index + 1;
    if (i % 2 == 0) {
      return (
        <div className="properties-row">
          <div
            key={index + 10}
            style={{
              marginBottom: `${index < propertiesList.length - 1 ? "10px" : "0px"
                }`,
            }}
            className="gp-properties-item"
          >
            <div className="property-key">{propertiesList[index - 1].key}</div>
            <div
              className="property-value cursor-pointer"
              onClick={() =>
                handleRedirection(
                  propertiesList[index - 1].key,
                  propertiesList[index - 1].key === "Hat" &&
                    propertiesList[index - 1].value.toLowerCase() === "hat"
                    ? "Newsboy"
                    : propertiesList[index - 1].value
                )
              }
            >
              {propertiesList[index - 1].key === "Hat" &&
                propertiesList[index - 1].value.toLowerCase() === "hat"
                ? "Newsboy"
                : propertiesList[index - 1].value}
            </div>
          </div>
          <div
            key={index}
            style={{
              marginBottom: `${index < propertiesList.length - 1 ? "10px" : "0px"
                }`,
            }}
            className="gp-properties-item"
          >
            <div className="property-key">{data.key}</div>
            <div
              className="property-value cursor-pointer"
              onClick={() =>
                handleRedirection(
                  data.key,
                  data.key === "Hat" && data.value.toLowerCase() === "hat"
                    ? "Newsboy"
                    : data.value
                )
              }
            >
              {data.key === "Hat" && data.value.toLowerCase() === "hat"
                ? "Newsboy"
                : data.value}
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className={`${className} gp-gangsta-properties-container`}>
      <div className="scroll-props">
        {propertiesList.map((data, index) => {
          let i = index + 1;
          if (i == propertiesList.length) {
            return (
              <div
                key={index}
                style={{
                  marginBottom: `${index < propertiesList.length - 1 ? "10px" : "0px"
                    }`,
                }}
                className="gp-properties-item"
              >
                <div className="property-key">{data.key}</div>
                <div
                  className="property-value cursor-pointer"
                  onClick={() =>
                    handleRedirection(
                      data.key,
                      data.key === "Hat" && data.value.toLowerCase() === "hat"
                        ? "Newsboy"
                        : data.value
                    )
                  }
                >
                  {data.key === "Hat" && data.value.toLowerCase() === "hat"
                    ? "Newsboy"
                    : data.value}
                </div>
              </div>
            );
          } else {
            return checkMod2(index, propertiesList, data);
          }
        })}
      </div>
    </div>
  );
}

export default GangstaProperties;
